import { pushSdAction } from './helpers.js';
import { ActionType } from './types.js';

const createCartAddAction = (object)=>{
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Add,
        name: 'add_to_cart',
        object
    };
    return action;
};
const createCartDeleteAction = (object)=>{
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Delete,
        name: 'remove_from_cart',
        object
    };
    return action;
};
const createUpdateQuantityAction = (updateAction)=>{
    let action;
    if (updateAction.updateType === 'increase') {
        action = createCartAddAction(updateAction.object);
    } else {
        action = createCartDeleteAction(updateAction.object);
    }
    return action;
};
/**
 * Public methods - use these outside this package
 */ /**
 * @deprecated - use the Data Layer for analytics
 */ const addToCartSdAction = (productObjects)=>{
    for (const productObject of productObjects){
        const action = createCartAddAction(productObject);
        action && pushSdAction(action);
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const updateQuantitySdAction = (actions)=>{
    for (const updateAction of actions){
        const action = createUpdateQuantityAction(updateAction);
        action && pushSdAction(action);
    }
};
/**
 * @deprecated - use the Data Layer for analytics
 */ const removeLineItemsSdAction = (objects)=>{
    for (const object of objects){
        const action = createCartDeleteAction(object);
        action && pushSdAction(action);
    }
};

export { addToCartSdAction, createCartAddAction, createCartDeleteAction, createUpdateQuantityAction, removeLineItemsSdAction, updateQuantitySdAction };
//# sourceMappingURL=cart-v2.js.map
